"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOMPANYING_REPORT_A3_ELEVATOR_OPTIONS = exports.ACCOMPANYING_REPORT_A3_GAS_CONNECTION_OPTIONS = exports.ACCOMPANYING_REPORT_A3_SEWER_CONNECTION_OPTIONS = exports.ACCOMPANYING_REPORT_A3_WATER_CONNECTION_OPTIONS = exports.ACCOMPANYING_REPORT_A3_HEATHING_METHOD_OPTIONS = exports.ACCOMPANYING_REPORT_A3_CONSTRUCTION_TYPE = exports.EMISSIONS_CATEGORIES = exports.DEMOLITION_PERMIT_A_FORMS = exports.BUILDING_PERMIT_A_FORMS = exports.DEMOLITION_PERMIT_B_FORMS = exports.BUILDING_PERMIT_B_FORMS = exports.ACCOMPANYING_REPORT_FORM_INITIAL_DATA = exports.B10_FORM_INITIAL_VALUES = exports.B9_FORM_INITIAL_VALUES = exports.B8_FORM_INITIAL_VALUES = exports.B7_FORM_INITIAL_VALUES = exports.B6_FORM_INITIAL_VALUES = exports.B5_FORM_INITIAL_VALUES = exports.B4_DEMOLITION_INITIAL_VALUES = exports.B4_FORM_INITIAL_VALUES = exports.B3_FORM_INITIAL_VALUES = exports.B2_FORM_INIT_VALUES = exports.B1_INITIAL_VALUES = exports.B3_INITIAL_VALUES = exports.B2_INITIAL_VALUES = void 0;
const enums_1 = require("./enums");
function generateRandomString(length = 8) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
const B3_SECTION_INITIAL_VALUES = {
    enabled: false,
    description: "",
    label: ""
};
const B4_SECTION_INITIAL_VALUES = {
    enabled: false,
    connectionCondition: "existing",
    material: "",
    length: "",
    connectionDimension: "",
    performanceCapacity: "",
    description: ""
};
exports.B2_INITIAL_VALUES = {
    b2: {
        technicalInfrastructure: {
            waterSupply: Object.assign({}, B4_SECTION_INITIAL_VALUES),
            sewage: Object.assign({}, B4_SECTION_INITIAL_VALUES),
            gasPipeline: Object.assign({}, B4_SECTION_INITIAL_VALUES),
            wiring: Object.assign({}, B4_SECTION_INITIAL_VALUES),
            disconnectionMethod: {
                enabled: false,
                description: ""
            }
        }
    }
};
exports.B3_INITIAL_VALUES = {
    b3: {
        terrainModifications: {
            terrainModifications: "",
            vegetationElements: "",
            biotechnicalMeasures: "",
            hasTerrainModifications: false,
            hasVegetationElements: false,
            hasBiotechnicalMeasures: false
        }
    }
};
exports.B1_INITIAL_VALUES = {
    test: "",
    radio: "email",
    person: "Person 1",
    readonly: {},
    b1a: {
        aiGenerated: "",
        aiGeneratedAccepted: false,
        isBuildingPlot: true,
        typeOfPlot: "",
        placement: {
            value: "",
            custom: false
        },
        shape: "",
        landSlope: "",
        previousUtilization: "",
        urbanization: "",
        surroundingArea: "",
        landscapeCharacter: true,
        landscapeCharacterDescription: "",
        newOrChange: "",
        currentState: "",
        technicalState: "",
        historicalState: "",
        bearingConstructionsCheck: "",
        usage: "",
        temporaryOrPermanent: "",
        temporaryFrom: new Date(),
        temporaryTo: new Date()
    },
    b1b: {
        complianceWithPlanningDocumentation: true,
        complianceWithPlanningDocumentationDescription: "",
        complianceWithPlanningGoalsTasks: true,
        complianceWithPlanningGoalsTasksDescription: ""
    },
    b1c: {
        culturalHeritageCompliance: true,
        planningGoalsCompliance: true,
        planningDocumentationCompliance: true,
        issuedExceptions: [
            {
                name: "",
                file: "",
                description: ""
            }
        ]
    },
    b1d: {
        custom: [
            {
                name: "",
                enabled: false,
                conclusion: "",
                files: []
            }
        ],
        pretext: `
        V projektové dokumentaci byly zohledněny podmínky závazných stanovisek dotčených
        orgánů, a to především v její textové části, situačních výkresech a
        architektonicko-stavební části. Veškerá stanoviska jsou přílohou projektové
        dokumentace (E - dokladová část).
    `,
        test: [
            {
                name: "Krajská hygienická stanice",
                checked: false,
                description: ""
            },
            {
                name: "Odbor dopravy",
                checked: false,
                description: ""
            },
            {
                name: "Odbor územního plánování",
                checked: false,
                description: ""
            },
            {
                name: "Odbor životního prostředí",
                checked: false,
                description: ""
            },
            {
                name: "Odbor ochrany prostředí",
                checked: false,
                description: ""
            },
            {
                name: "Odbor dopravy",
                checked: false,
                description: ""
            },
            {
                name: "Hasičský záchranný sbor",
                checked: false,
                description: ""
            },
            {
                name: "Vodoprávní úřad",
                checked: false,
                description: ""
            },
            {
                name: "Obecní úřad s rozšířenou působností",
                checked: false,
                description: ""
            },
            {
                custom: true,
                name: "",
                checked: false,
                description: ""
            }
        ]
    },
    b1e: {
        issuedExceptions: [],
        geologicalSurvey: false,
        geologicalSurveyConclusion: "",
        hydrogeologicalSurvey: false,
        hydrogeologicalSurveyConclusion: "",
        historicalBuildingSurvey: false,
        historicalBuildingSurveyConclusion: "",
        engineerGeologySurvey: false,
        engineerGeologySurveyConclusion: "",
        radonMeasurement: false,
        radonMeasurementLevel: "",
        radonMeasurementConclusion: "",
        custom: [
            {
                name: "",
                enabled: false,
                conclusion: "",
                files: []
            }
        ]
    },
    b1f: {
        territoryProtection: {
            enabled: false,
            conclusion: ""
        }
    },
    b1g: {
        floodArea: {
            enabled: false,
            measures: "",
            positions: "",
            forms: ""
        },
        underminedArea: {
            enabled: false,
            measures: "",
            positions: "",
            forms: ""
        },
        others: [
            {
                name: "",
                enabled: false,
                measures: ""
            }
        ],
        sanitation: {
            enabled: false,
            details: "",
            permissionRequired: "",
            form: "",
            extraApproval: false
        },
        demolition: {
            enabled: false,
            details: "",
            permissionRequired: "",
            form: "",
            extraApproval: false
        },
        treeFelling: {
            enabled: false,
            details: "",
            permissionRequired: "",
            form: ""
        },
        impactOnSurroundingBuildings: {
            enabled: false,
            measures: ""
        },
        impactOnSurroundingLands: {
            enabled: false,
            measures: ""
        },
        protectionOfSurroundings: {
            enabled: false,
            measures: ""
        },
        impactOnDrainageConditions: {
            enabled: false,
            measures: ""
        }
    },
    b1h: {
        impactOnSurroundingBuildings: {
            enabled: false,
            measures: ""
        },
        impactOnSurroundingLands: {
            enabled: false,
            measures: ""
        },
        protectionOfSurroundings: {
            enabled: false,
            measures: ""
        },
        impactOnDrainageConditions: {
            enabled: false,
            measures: ""
        }
    },
    b1i: {
        sanitation: {
            enabled: false,
            details: "",
            permissionRequired: "",
            form: "",
            extraApproval: false
        },
        demolition: {
            enabled: false,
            details: "",
            permissionRequired: "",
            form: "",
            extraApproval: false
        },
        treeFelling: {
            enabled: false,
            details: "",
            permissionRequired: "",
            form: ""
        }
    },
    b1j: {
        landSeizureAgricultural: {
            enabled: false,
            details: ""
        },
        landSeizureForest: {
            enabled: false,
            details: ""
        },
        typeOfTechnology: {
            enabled: false,
            details: ""
        },
        capacity: {
            enabled: false,
            details: ""
        }
    },
    b1k: {
        connectionToTransportInfrastructure: {
            enabled: false,
            newOrExistingExit: ""
        },
        connectionToTechnicalInfrastructure: {
            waterSupply: {
                enabled: false,
                newOrExistingConnection: ""
            },
            sewerage: {
                enabled: false,
                newOrExistingConnection: ""
            },
            stormDrain: {
                enabled: false,
                newOrExistingConnection: "",
                disposalOnOwnLand: ""
            },
            gasPipeline: {
                enabled: false,
                newOrExistingConnection: ""
            },
            electricity: {
                enabled: false,
                newOrExistingConnection: ""
            },
            communicationLines: {
                enabled: false,
                newOrExistingConnection: ""
            },
            other: "",
            custom: [
                {
                    name: "",
                    enabled: false,
                    newOrExistingConnection: "",
                    description: ""
                }
            ]
        },
        barrierFreeAccess: {
            enabled: false,
            details: ""
        }
    },
    b1l: {
        objectAndTimeConnections: {
            allAtOnce: true,
            custom: ""
        },
        conditionalInvestments: false,
        conditionalInvestmentsDetails: "",
        triggeredInvestments: false,
        triggeredInvestmentsDetails: "",
        relatedInvestments: false,
        relatedInvestmentsDetails: ""
    },
    b1m: {
        divisionToStages: {
            enabled: false,
            details: ""
        }
    },
    b1o: {
        measurements: {
            notInProject: true
        }
    }
};
exports.B2_FORM_INIT_VALUES = {
    b2: {
        characteristics: {
            a: {
                newOrChange: "",
                currentState: "",
                technicalState: "",
                historicalState: "",
                bearingConstructionsCheck: ""
            },
            b: {
                usage: ""
            },
            c: {
                temporaryOrPermanent: "",
                temporaryFrom: new Date(),
                temporaryTo: new Date()
            },
            d: {
                barrierFreeExceptions: false,
                technicalExceptions: false,
                technicalExceptionsDescription: "",
                barrierFreeExceptionsDescription: ""
            },
            e: {
                doss: ""
            },
            f: {
                constructionProtection: false
            },
            g: {
                buildUpArea: "",
                enclosedArea: "",
                usableArea: "",
                units: [
                    {
                        value: ""
                    }
                ]
            },
            h: {
                constructionBalanceSubstanceConsumtion: false,
                constructionBalanceRainWater: false,
                constructionBalanceWasteAndEmissions: false,
                constructionBalanceEnergyConsumption: false
            },
            i: {
                divisionToStages: ""
            },
            j: {
                estimatedCosts: ""
            }
        },
        barrierFreeUsage: {
            isBarrierFree: false,
            description: "Stavba je navržena a bude provedena v souladu s vyhláškou č. 398/2009 Sb. - Vyhláška o obecných technických požadavcích zabezpečujících bezbariérové užívání staveb  "
        },
        safety: {
            description: "Stavba je navržena a bude provedena v souladu se všemi  platnými normami, předpisy a vyhláškami, které zabezpečují bezpečnost při užívání. Mezi hlavní patří:<br/>" +
                "<br/>" +
                "- vyhláška č. 268/2009 Sb. o obecných technických požadavcích na stavby<br/>" +
                "- vyhláška č. 398/2009 Sb., o obecných technických požadavcích zabezpečujících bezbariérové užívání staveb<br/>" +
                "- Vyhláška č. 246/2001 Sb. o stanovení podmínek požární bezpečnosti a výkonu státního požárního dozoru (vyhláška o požární prevenci)<br/>" +
                "- ČSN 73 4130 – schodiště a šikmé rampy<br/>" +
                "- ČSN 74 3305 – ochranná zábradlí<br/>" +
                "- ČSN 73 0810 – Požární bezpečnost staveb – společná ustanovení<br/>" +
                "- ČSN 33 2000-4-41 ED.3 - elektrické instalace nízkého napětí - Část 4-41: Ochranná opatření pro zajištění bezpečnosti - Ochrana před úrazem elektrickým proudem<br/>" +
                "- A další<br/>" +
                "<br/>" +
                "Hlavní uzávěry, vypínače a další prvky, které to vyžadují, budou označeny příslušnými tabulkami.<br/>" +
                "<br/>" +
                "Veškeré technologie umístěné v objektu, budou dodány včetně dokladů o způsobu bezpečného užívání. <br/>" +
                "<br/>" +
                "K jednotlivým profesím, zařízením, instalacím a rozvodům budou vystaveny revizní zprávy o způsobilosti k bezpečnému provozu. <br/>" +
                "<br/>" +
                "Zařízení technického vybavení objektu budou podléhat pravidelnému servisu a budou ovládána zaškolenými pracovníky.“<br/>"
        },
        fireSafety: {
            description: "Řešeno samostatnou částí projektové dokumentace D.1.3 - Požárně-bezpečnostní řešení"
        },
        energyAndHeat: {
            description: "Viz. průkaz energetické náročnosti budovy, který je součástí dokladové části projektové dokumentace."
        },
        hygiene: {
            others: [
                {
                    indexIdentifier: generateRandomString(),
                    name: "",
                    description: ""
                }
            ]
        },
        externalFactorsProtection: {
            wayWardStream: false,
            technicalSeismicity: false,
            noise: false,
            floodProtection: false,
            underMining: false,
            methane: false,
            others: [
                {
                    name: "",
                    description: ""
                }
            ]
        },
        objectCharacteristics: {
            building: "",
            mechanicsAndStability: "",
            constructionAndMaterial: {
                vertical: {
                    description: "",
                    grid: [
                        {
                            name: "",
                            width: "",
                            description: "",
                            layers: [
                                {
                                    name: "",
                                    width: "",
                                    description: ""
                                }
                            ]
                        }
                    ]
                },
                horizontal: {
                    description: "",
                    grid: [
                        {
                            name: "",
                            width: "",
                            description: "",
                            layers: [
                                {
                                    name: "",
                                    width: "",
                                    description: ""
                                }
                            ]
                        }
                    ]
                },
                foundation: {
                    description: "",
                    grid: [
                        {
                            name: "",
                            width: "",
                            description: "",
                            layers: [
                                {
                                    name: "",
                                    width: "",
                                    description: ""
                                }
                            ]
                        }
                    ]
                },
                roof: {
                    description: "",
                    grid: [
                        {
                            name: "",
                            width: "",
                            description: "",
                            layers: [
                                {
                                    name: "",
                                    width: "",
                                    description: ""
                                }
                            ]
                        }
                    ]
                },
                isolation: {
                    description: "",
                    grid: [
                        {
                            name: "",
                            width: "",
                            description: "",
                            layers: [
                                {
                                    name: "",
                                    width: "",
                                    description: ""
                                }
                            ]
                        }
                    ]
                },
                fillings: {
                    description: "",
                    grid: [
                        {
                            name: "",
                            width: "",
                            description: "",
                            layers: [
                                {
                                    name: "",
                                    width: "",
                                    description: ""
                                }
                            ]
                        }
                    ]
                },
                other: {
                    description: "",
                    grid: [
                        {
                            name: "",
                            width: "",
                            description: "",
                            layers: [
                                {
                                    name: "",
                                    width: "",
                                    description: ""
                                }
                            ]
                        }
                    ]
                }
            }
        }
    }
};
exports.B3_FORM_INITIAL_VALUES = {
    readonly: {},
    b3: {
        overallConceptSolutions: {
            constructionTechnicalSolution: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: "Stavebně technické řešení" }),
            technologicalSolution: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: "Technologické řešení" })
        },
        overallAccessibilityConditions: {
            individualParts: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `a) celkové řešení přístupnosti se specifikací jednotlivých části, které podléhají
            požadavkům na přístupnost, včetně dopadů předčasného užívání a zkušebního provozu a
            vlivu na okolí` }),
            proposedPrecautionsDescription: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `b) popis navržených opatření - zejména přístup ke stavbě, prostory stavby a systémy
            určené pro užívání veřejností` }),
            accessibilityImpactDescription: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `c) popis dopadů na přístupnost z hlediska uplatnění závažných územně technických nebo
            stavebně technických důvodů nebo jiných veřejných zájmů` })
        },
        safetyPrinciples: {
            description: ""
        },
        basicTechnicalDescription: {
            a: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `a) popis stávajícího stavu` }),
            b: {
                label: "b) popis navrženého stavebně technického a konstrukčního řešení",
                constructionTechnicalSolution: {
                    enabled: false,
                    description: ""
                },
                constructionSolution: {
                    enabled: false,
                    description: ""
                }
            }
        },
        technicalDevices: {
            a: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `a) popis stávajícího stavu` }),
            b: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `b) popis navrženého řešení` }),
            c: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `c) energetické výpočty` })
        },
        fireSafety: {
            a: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `a) charakteristiky a kritéria pro stanovení kategorie stavby podle požadavků jiného právního předpisu - výška stavby, zastavěná plocha, počet
podlaží, počet osob, pro který je stavba určena, nebo jiný parametr stavby, zejména světlá výška podlaží nebo délka tunelu apod.
` }),
            b: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `b) kritéria - třída využití, přítomnost nebezpečných látek nebo jiných rizikových faktorů prohlášení stavby za kulturní památku` })
        },
        energyConservation: {
            option: "none",
            description: ""
        },
        hygienicRequirements: {
            ventilation: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Větrání` }),
            lighting: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Osvětlení` }),
            sunlight: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Proslunění` }),
            shading: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Stínění` }),
            waterSupply: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Zásobování vodou` }),
            noiseProtection: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Ochrana proti hluku` }),
            sewage: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Odpady` }),
            other: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Další` })
        },
        protectionAgainstEnvironmentalFactors: {
            floodMeasures: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Protipovodňová opatření` }),
            radonLeaks: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Ochrana před pronikáním radonu z podloží` }),
            protectionAgainstStrayCurrents: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Ochrana před bludnými proudy` }),
            protectionAgainstSeismicity: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Ochrana před technickou i přírodní seizmicitou` }),
            protectionAgainstGroundwater: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Ochrana před agresivní a tlakovou podzemní vodou` }),
            protectionAgainstNoise: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Ochrana před hlukem a ostatními účinky` }),
            influenceOfUndermining: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Vliv poddolování` }),
            methaneOccurrence: Object.assign(Object.assign({}, B3_SECTION_INITIAL_VALUES), { label: `Výskyt metanu` })
        }
    }
};
exports.B4_FORM_INITIAL_VALUES = {
    b4: {
        technicalInfrastructureConnection: {
            waterSupply: Object.assign({}, B4_SECTION_INITIAL_VALUES),
            sewage: Object.assign({}, B4_SECTION_INITIAL_VALUES),
            drainage: Object.assign({}, B4_SECTION_INITIAL_VALUES),
            gasPipeline: Object.assign({}, B4_SECTION_INITIAL_VALUES),
            wiring: Object.assign({}, B4_SECTION_INITIAL_VALUES),
            communicationLine: Object.assign({}, B4_SECTION_INITIAL_VALUES),
            other: Object.assign({}, B4_SECTION_INITIAL_VALUES)
        }
    }
};
exports.B4_DEMOLITION_INITIAL_VALUES = {
    b4: {
        demolitionOrganization: {
            mediaNeeds: {
                enabled: false,
                description: ""
            },
            siteDrainage: {
                enabled: false,
                description: ""
            },
            siteConnection: {
                enabled: false,
                description: ""
            },
            impactOnSurroundings: {
                enabled: false,
                description: ""
            },
            maximumOccupancy: {
                enabled: false,
                description: ""
            },
            accessibilityRequirements: {
                enabled: false,
                description: ""
            },
            wasteManagement: {
                enabled: false,
                description: ""
            },
            environmentalProtection: {
                enabled: false,
                description: ""
            },
            safetyPrinciples: {
                enabled: false,
                description: ""
            },
            barrierFreeModifications: {
                enabled: false,
                description: ""
            },
            trafficMeasures: {
                enabled: false,
                description: ""
            }
        }
    }
};
exports.B5_FORM_INITIAL_VALUES = {
    b5: {
        transportSolution: {
            enabled: false,
            description: "",
            firstClass: false,
            secondClass: false,
            thirdClass: false,
            local: false,
            purpose: false,
            custom: {
                enabled: false,
                description: ""
            },
            newOrExisting: {
                enabled: false,
                description: ""
            },
            connectionToTraffic: "",
            reroutes: {
                enabled: false,
                description: ""
            },
            bikeTracks: {
                enabled: false,
                description: ""
            },
            staticTraffic: {
                enabled: false,
                description: ""
            },
            accessibilitySolution: {
                enabled: false,
                description: ""
            },
            obstacleFreeAccess: {
                enabled: false,
                description: ""
            }
        }
    }
};
exports.B6_FORM_INITIAL_VALUES = {
    b6: {
        vegetationAndTerrain: {
            enabled: false,
            description: ""
        }
    }
};
exports.B7_FORM_INITIAL_VALUES = {
    b7: {
        environmentalImpact: {
            natureAndLandscape: {
                enabled: false,
                description: ""
            },
            natura2000: {
                enabled: false,
                description: ""
            },
            outdoorLighting: {
                enabled: false,
                description: ""
            },
            asbestos: {
                enabled: false,
                description: ""
            },
            noiseAndVibrations: {
                enabled: false,
                description: ""
            },
            water: {
                enabled: false,
                description: ""
            },
            waste: {
                enabled: false,
                description: ""
            },
            soil: {
                enabled: false,
                description: ""
            },
            climateAndAir: {
                enabled: false,
                description: ""
            },
            stationarySources: {
                enabled: false,
                description: ""
            }
        },
        eiaConsideration: {
            enabled: false,
            description: ""
        },
        eiaComplianceDescription: {
            enabled: false,
            description: ""
        },
        integratedPermitCompliance: {
            enabled: false,
            description: ""
        }
    }
};
exports.B8_FORM_INITIAL_VALUES = {
    b8: {
        technicalInfrastructureConnection: {
            waterSupply: Object.assign({}, B4_SECTION_INITIAL_VALUES),
            sewage: Object.assign({}, B4_SECTION_INITIAL_VALUES),
            drainage: Object.assign({}, B4_SECTION_INITIAL_VALUES)
        }
    }
};
exports.B9_FORM_INITIAL_VALUES = {
    b9: {
        citizenAlertSystem: {
            enabled: false,
            description: ""
        },
        populationShelter: {
            enabled: false,
            description: ""
        },
        protectionAgainstSubstances: {
            enabled: false,
            description: ""
        },
        floodProtection: {
            enabled: false,
            description: ""
        },
        buildingSelfSufficiency: {
            enabled: false,
            description: ""
        },
        civilProtection: {
            enabled: false,
            description: ""
        }
    }
};
exports.B10_FORM_INITIAL_VALUES = {
    b10: {
        traficAndtechnicalInfrastructureConnection: {
            waterSupply: {
                enabled: false,
                description: ""
            },
            electricity: {
                enabled: false,
                description: ""
            },
            sewageAndRainWater: {
                enabled: false,
                description: ""
            },
            traffic: {
                enabled: false,
                description: ""
            },
            other: {
                enabled: false,
                description: ""
            }
        },
        protectionOfSurroundings: {
            constructionSurroundingsProtection: {
                enabled: false,
                description: ""
            },
            urbanRenewal: {
                enabled: false,
                description: ""
            },
            disassembly: {
                enabled: false,
                description: ""
            },
            demolition: {
                enabled: false,
                description: ""
            },
            deconstruction: {
                enabled: false,
                description: ""
            },
            treeFelling: {
                enabled: false,
                description: ""
            },
            other: {
                enabled: false,
                description: ""
            }
        },
        constructionEntrance: {
            description: ""
        },
        maximumLandOccupation: {
            enabled: false,
            permanent: {
                enabled: false,
                description: ""
            },
            temporary: {
                enabled: false,
                description: ""
            }
        },
        environmentProtection: {
            description: ""
        },
        OHS: {
            description: `
      <p>
        Základním předpisem, který je nutno dodržovat při realizaci prací podle tohoto projektu vzhledem k bezpečnosti práce, je zákon č. 309/2006 Sb., Zákon o zajištění dalších podmínek bezpečnosti
        a ochrany zdraví při práci.
      </p>
      <p>Dále je nutno se řídit těmito předpisy:</p>
      <br/>
      <p>
        -     Směrnice Rady 92/57/EHS, O minimálních požadavcích na bezpečnost a ochranu zdraví na dočasných nebo mobilních staveništích
      </p>
      <p>
              -     Zákon č. 355/1999 Sb., O technických podmínkách provozu silničních vozidel na pozemních komunikacích
      </p>
      <p>
              -     Zákon č. 150/2000 Sb., O silniční dopravě
      </p>
      <p>
              -     Zákon č. 102/2000 Sb., O pozemních komunikacích
      </p>
      <p>
              -     Zákon č. 361/2000 Sb., O provozu na pozemních komunikacích
      </p>
      <p>
              -     Zákon č. 251/2005 Sb., O inspekci práce ukazatelů, biologických testů a náležitosti hlášení prací s azbestem a biologickými činiteli
      </p>
      <p>
        -     Nařízení vlády č. 362/2005 Sb., O bližších požadavcích na bezpečnost a ochranu zdraví při práci na pracovištích s nebezpečím pádu z výšky nebo do hloubky
      </p>
      <p>
        -     Nařízení vlády č. 591/2006 Sb., O bližších minimálních požadavcích na bezpečnost a ochranu zdraví při práci na staveništích
      </p>
      <p>
        -     Nařízení vlády č. 361/2007 Sb. (s novelami č. 68/2010 Sb., č. 93/2012 Sb.), O ochraně zdraví zaměstnanců
      </p>
      <p>
        -     Nařízení vlády č. 1/2008 Sb. (se změnami č. 106/2010 Sb.), O ochraně zdraví před neionizujícím zářením
      </p>
      <p>
        -     Nařízení vlády č. 272/2011 Sb., O ochraně zdraví před nepříznivými účinky hluku a vibrací
      </p>
      <p>
              -     ČS 050610 – Bezpečnostní předpisy pro svařování plamenem
      </p>
      <p>
        -     ČS 050631 – Bezpečnostní předpisy pro svařování elektrickým obloukem
      </p>
      <br/>
      <p>
        Při provádění stavebních prací podle tohoto projektu je dodavatel povinen též postupovat v souladu s vyhláškou č. 324/1990 Sb. Českého úřadu bezpečnosti práce a Českého báňského úřadu o
        bezpečnosti práce a technických zařízeních při stavebních pracích.
      </p>
      <p>
        Při provádění prací na staveništi je třeba dodržovat pravidla BOZP, včetně zákonných požadavků, ustanovení norem (ČSN), bezpečnostních a hygienických předpisů platných v době provádění
        stavby. Zvláště pak připomínám respektovat Zákoník práce ve znění pozdějších změn a doplněn
      </p>
      <p>
        Před zahájením prací musí být všichni pracovníci na stavbě poučeni o bezpečnostních předpisech pro všechny práce, které přicházejí do úvahy. Tato opatření musí být řádně zajištěna a
        kontrolována. Všichni pracovníci musí používat předepsané ochranné pomůcky. Na pracovišti musí být udržován pořádek a čistota. Musí být dbáno na ochrany proti požáru a protipožární
        pomůcky se musí udržovat v pohotovosti.
      </p>
      <p>
        Práce na el. zařízeních smí provádět pouze k tomu určený přezkoušený elektrikář. Připojení či odpojení elektrických vedení se mohou provádět jen za odborného dozoru správce/vlastníka sítě.
      </p>
      <p>
        Práce na stavbě musí být prováděny v souladu se zhotovitelem zpracovanými technologickými postupy pro jednotlivé činnosti
      </p>
      <p>
        Práce ve výškách se budou řídit bezpečnostními předpisy dle platné legislativy v posledním znění.
      </p>
      <br/>
      <p>
        Plán bezpečnosti a ochrany zdraví při práci:
      </p>
      <p>
        V souladu s §15, odst. 2, zákona č. 309/2006 Sb. budou-li na staveništi vykonávány práce a činnosti vystavující fyzickou osobu zvýšenému ohrožení života nebo poškození zdraví, které jsou
        stanoveny prováděcím předpisem, stejně jako v případech podle odst. 1 §15, zadavatel stavby zajistí, aby před zahájením prací na staveništi byl zpracován plán bezpečnosti a ochrany zdraví při
        práci na staveništi (dále jen „plán BOZP“) podle druhu a velikosti stavby tak, aby plně vyhovoval potřebám zajištění bezpečné a zdraví neohrožující práce.
      </p>

      `
        },
        earthWorks: {
            earthWorksBalance: {
                enabled: false,
                description: ""
            },
            soilDelivery: {
                enabled: false,
                description: ""
            },
            storageArea: {
                enabled: false,
                description: ""
            }
        },
        heightMachineryLimits: {
            enabled: true,
            description: ""
        },
        requirements: {
            gradualCommissioning: {
                enabled: false,
                description: ""
            },
            processAndMethodOfConstruction: {
                enabled: false,
                description: ""
            },
            other: {
                enabled: false,
                description: ""
            }
        },
        constructionPhases: {
            enabled: false,
            description: ""
        },
        temporaryObjects: {
            enabled: false,
            description: ""
        }
    }
};
exports.ACCOMPANYING_REPORT_FORM_INITIAL_DATA = {
    a1: {
        constructionName: "",
        builder: undefined,
        builders: [undefined],
        documentationAuthor: undefined,
        primaryDocumentationAuthor: undefined,
        otherAuthors: [
            {
                label: "",
                author: undefined,
                indexIdentifier: generateRandomString()
            }
        ],
        surveyingEngineers: [
            {
                authorizationNumber: "",
                author: undefined,
                indexIdentifier: generateRandomString()
            }
        ],
        places: [
            {
                indexIdentifier: generateRandomString(),
                municipality: undefined,
                siteFacilities: false,
                statutoryServitudes: false
            }
        ]
    },
    a2: {
        baseDocumentations: [{ indexIdentifier: generateRandomString() }]
    },
    a3: {
        enclosedSpace: "",
        builtUpArea: "",
        floorArea: "",
        numAboveGroundFloors: "",
        numUndergroundFloors: "",
        usageMethod: "",
        constructionType: "",
        heatingMethod: "",
        waterConnection: "",
        sewerConnection: "",
        gasConnection: "",
        elevator: "",
        elevatorDescription: ""
    },
    a4: {
        depthOfConstruction: "",
        heightOfConstruction: "",
        numberOfPeople: "",
        plannedStartDate: null,
        plannedEndDate: null
    }
};
exports.BUILDING_PERMIT_B_FORMS = [
    enums_1.ProjectFormEnum.TECHNICAL_FORM_B1,
    enums_1.ProjectFormEnum.TECHNICAL_FORM_B2,
    enums_1.ProjectFormEnum.TECHNICAL_FORM_B3,
    enums_1.ProjectFormEnum.TECHNICAL_FORM_B4,
    enums_1.ProjectFormEnum.TECHNICAL_FORM_B5,
    enums_1.ProjectFormEnum.TECHNICAL_FORM_B6,
    enums_1.ProjectFormEnum.TECHNICAL_FORM_B7,
    enums_1.ProjectFormEnum.TECHNICAL_FORM_B8,
    enums_1.ProjectFormEnum.TECHNICAL_FORM_B9,
    enums_1.ProjectFormEnum.TECHNICAL_FORM_B10
];
exports.DEMOLITION_PERMIT_B_FORMS = [
    enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B1,
    enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B2,
    enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B3,
    enums_1.ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B4,
];
exports.BUILDING_PERMIT_A_FORMS = [enums_1.ProjectFormEnum.ACCOMPANYING_REPORT_FORM_A1];
exports.DEMOLITION_PERMIT_A_FORMS = [enums_1.ProjectFormEnum.DEMOLITION_ACCOMPANYING_REPORT_FORM_A1];
exports.EMISSIONS_CATEGORIES = [
    {
        code: "17 01",
        name: "Beton, cihly, tašky a keramika",
        items: [
            { code: "17 01 01", name: "Beton" },
            { code: "17 01 02", name: "Cihly" },
            { code: "17 01 03", name: "Tašky a keramické výrobky" },
            {
                code: "17 01 06",
                name: "Směsi nebo oddělené frakce betonu, cihel, tašek a keramických výrobků obsahující nebezpečné látky"
            },
            {
                code: "17 01 07",
                name: "Směsi nebo oddělené frakce betonu, cihel, tašek a keramických výrobků neuvedené pod číslem 17 01 06"
            }
        ]
    },
    {
        code: "17 02",
        name: "Dřevo, sklo a plasty",
        items: [
            { code: "17 02 01", name: "Dřevo" },
            { code: "17 02 02", name: "Sklo" },
            { code: "17 02 03", name: "Plasty" },
            {
                code: "17 02 04",
                name: "Sklo, plasty a dřevo obsahující nebezpečné látky nebo nebezpečnými látkami znečištěné"
            }
        ]
    },
    {
        code: "17 03",
        name: "Asfaltové směsi, dehet a výrobky z dehtu",
        items: [
            { code: "17 03 01", name: "Asfaltové směsi obsahující dehet" },
            {
                code: "17 03 02",
                name: "Asfaltové směsi neuvedené pod číslem 17 03 01"
            },
            { code: "17 03 03", name: "Uhelný dehet a výrobky z dehtu" }
        ]
    },
    {
        code: "17 04",
        name: "Kovy (včetně jejich slitin)",
        items: [
            { code: "17 04 01", name: "Měď, bronz, mosaz" },
            { code: "17 04 02", name: "Hliník" },
            { code: "17 04 03", name: "Olovo" },
            { code: "17 04 04", name: "Zinek" },
            { code: "17 04 05", name: "Železo a ocel" },
            { code: "17 04 06", name: "Cín" },
            { code: "17 04 07", name: "Směsné kovy" },
            {
                code: "17 04 09",
                name: "Kovový odpad znečištěný nebezpečnými látkami"
            },
            {
                code: "17 04 10",
                name: "Kabely obsahující ropné látky, uhelný dehet a jiné nebezpečné látky"
            },
            {
                code: "17 04 11",
                name: "Kabely neuvedené pod číslem 17 04 10"
            }
        ]
    },
    {
        code: "17 05",
        name: "Zemina (včetně vytěžené zeminy z kontaminovaných míst), kamení, vytěžená jalová hornina a hlušina",
        items: [
            {
                code: "17 05 03",
                name: "Zemina a kamení obsahující nebezpečné látky"
            },
            {
                code: "17 05 04",
                name: "Zemina a kamení neuvedené pod číslem 17 05 03"
            },
            {
                code: "17 05 04 01",
                name: "Sedimenty vytěžené z koryt vodních toků a vodních nádrží"
            },
            {
                code: "17 05 05",
                name: "Vytěžená jalová hornina a hlušina obsahující nebezpečné látky"
            },
            {
                code: "17 05 06",
                name: "Vytěžená jalová hornina a hlušina neuvedená pod číslem 17 05 05"
            },
            {
                code: "17 05 07",
                name: "Štěrk ze železničního svršku obsahující nebezpečné látky"
            },
            {
                code: "17 05 08",
                name: "Štěrk ze železničního svršku neuvedený pod číslem 17 05 07"
            }
        ]
    },
    {
        code: "17 06",
        name: "Izolační materiály a stavební materiály s obsahem azbestu",
        items: [
            { code: "17 06 01", name: "Izolační materiál s obsahem azbestu" },
            {
                code: "17 06 03",
                name: "Jiné izolační materiály, které jsou nebo obsahují nebezpečné látky"
            },
            {
                code: "17 06 03 01",
                name: "Izolační materiály na bázi polystyrenu obsahující nebezpečné látky"
            },
            {
                code: "17 06 04",
                name: "Izolační materiály neuvedené pod čísly 17 06 01 a 17 06 03"
            },
            {
                code: "17 06 04 01",
                name: "Izolační materiály na bázi polystyrenu s obsahem POPs vyžadující specifický způsob nakládání s ohledem na nařízení o POPs"
            },
            {
                code: "17 06 04 02",
                name: "Izolační materiály na bázi polystyrenu"
            },
            {
                code: "17 06 05",
                name: "Stavební materiály obsahující azbest"
            }
        ]
    },
    {
        code: "17 08",
        name: "Stavební materiál na bázi sádry",
        items: [
            {
                code: "17 08 01",
                name: "Stavební materiály na bázi sádry znečištěné nebezpečnými látkami"
            },
            {
                code: "17 08 02",
                name: "Stavební materiály na bázi sádry neuvedené pod číslem 17 08 01"
            }
        ]
    },
    {
        code: "17 09",
        name: "Jiné stavební a demoliční odpady",
        items: [
            { code: "17 09 01", name: "Stavební a demoliční odpady obsahující rtuť" },
            {
                code: "17 09 02",
                name: "Stavební a demoliční odpady obsahující PCB (např. těsnící materiály obsahující PCB, podlahoviny na bázi pryskyřic obsahující PCB, utěsněné zasklené dílce obsahující PCB, kondenzátory obsahující PCB)"
            },
            {
                code: "17 09 03",
                name: "Jiné stavební a demoliční odpady (včetně směsných stavebních a demoličních odpadů) obsahující nebezpečné látky"
            },
            {
                code: "17 09 04",
                name: "Směsné stavební a demoliční odpady neuvedené pod čísly 17 09 01, 17 09 02 a 17 09 03"
            }
        ]
    }
];
exports.ACCOMPANYING_REPORT_A3_CONSTRUCTION_TYPE = [
    {
        value: "1 Nezjištěno",
        label: "1 Nezjištěno"
    },
    {
        value: "2 Zděný z nepálených cihel",
        label: "2 Zděný z nepálených cihel"
    },
    {
        value: "3 Zděný cihelný",
        label: "3 Zděný cihelný"
    },
    {
        value: "4 Zděný kamenný",
        label: "4 Zděný kamenný"
    },
    {
        value: "5 Zděný jiné",
        label: "5 Zděný jiné"
    },
    {
        value: "6 Zděný smíšený",
        label: "6 Zděný smíšený"
    },
    {
        value: "7 Monolitický betonový",
        label: "7 Monolitický betonový"
    },
    {
        value: "8 Montované stěnové panely betonové",
        label: "8 Montované stěnové panely betonové"
    },
    {
        value: "9 Montované stěnové panely dřevěné",
        label: "9 Montované stěnové panely dřevěné"
    },
    {
        value: "10 Montované stěnové panely jiné",
        label: "10 Montované stěnové panely jiné"
    },
    {
        value: "11 Dřevo – sruby a roubenky",
        label: "11 Dřevo – sruby a roubenky"
    },
    {
        value: "12 Dřevo – lehký rámcový skelet – panelová montáž",
        label: "12 Dřevo – lehký rámcový skelet – panelová montáž"
    },
    {
        value: "13 Dřevo – lehký rámcový skelet – staveništní montáž",
        label: "13 Dřevo – lehký rámcový skelet – staveništní montáž"
    },
    {
        value: "14 Dřevo – těžký skelet",
        label: "14 Dřevo – těžký skelet"
    },
    {
        value: "15 Panely z masivního dřeva",
        label: "15 Panely z masivního dřeva"
    },
    {
        value: "16 Dřevo – ostatní dřevěné konstrukce",
        label: "16 Dřevo – ostatní dřevěné konstrukce"
    },
    {
        value: "17 Kombinovaný",
        label: "17 Kombinovaný"
    },
    {
        value: "18 Speciální a jiné",
        label: "18 Speciální a jiné"
    }
];
exports.ACCOMPANYING_REPORT_A3_HEATHING_METHOD_OPTIONS = [
    {
        value: '1 Nezjištěno',
        label: '1 Nezjištěno',
    },
    {
        value: '2 Ústřední dálkové',
        label: '2 Ústřední dálkové',
    },
    {
        value: '3 Ústřední domovní',
        label: '3 Ústřední domovní',
    },
    {
        value: '4 Ústřední bytové',
        label: '4 Ústřední bytové',
    },
    {
        value: '5 Kombinované',
        label: '5 Kombinované',
    },
    {
        value: '6 Lokální zdroje',
        label: '6 Lokální zdroje',
    },
    {
        value: '7 Bez vytápění',
        label: '7 Bez vytápění',
    },
];
exports.ACCOMPANYING_REPORT_A3_WATER_CONNECTION_OPTIONS = [
    {
        value: '1 Nezjištěno',
        label: '1 Nezjištěno',
    },
    {
        value: '2 bez zdroje',
        label: '2 bez zdroje',
    },
    {
        value: '3 Centrální zdroj',
        label: '3 Centrální zdroj',
    },
    {
        value: '4 Lokální zdroj',
        label: '4 Lokální zdroj',
    },
    {
        value: '5 Lokální zásobník',
        label: '5 Lokální zásobník',
    },
    {
        value: '6 Kombinované',
        label: '6 Kombinované',
    },
];
exports.ACCOMPANYING_REPORT_A3_SEWER_CONNECTION_OPTIONS = [
    {
        value: '1 Nezjištěno',
        label: '1 Nezjištěno',
    },
    {
        value: '2 Bez zajištění',
        label: '2 Bez zajištění',
    },
    {
        value: '3 Jednotná kanalizace s centrální čistírnou odpadních vod',
        label: '3 Jednotná kanalizace s centrální čistírnou odpadních vod',
    },
    {
        value: '4 Jednotná kanalizace bez centrální čistírny odpadních vod',
        label: '4 Jednotná kanalizace bez centrální čistírny odpadních vod',
    },
    {
        value: '5 Oddílná kanalizace s centrální čistírnou odpadních vod',
        label: '5 Oddílná kanalizace s centrální čistírnou odpadních vod',
    },
    {
        value: '6 Lokální čistírna odpadních vod',
        label: '6 Lokální čistírna odpadních vod',
    },
    {
        value: '7 Lokální zásobník',
        label: '7 Lokální zásobník',
    },
    {
        value: '8 Kombinované',
        label: '8 Kombinované',
    },
];
exports.ACCOMPANYING_REPORT_A3_GAS_CONNECTION_OPTIONS = [
    {
        value: '1 Nezjištěno',
        label: '1 Nezjištěno',
    },
    {
        value: '2 Bez zdroje',
        label: '2 Bez zdroje',
    },
    {
        value: '3 Veřejná síť',
        label: '3 Veřejná síť',
    },
    {
        value: '4 Domovní zásobník – bez rozlišení',
        label: '4 Domovní zásobník – bez rozlišení',
    },
    {
        value: '5 Domovní zásobník – LPG',
        label: '5 Domovní zásobník – LPG',
    },
    {
        value: '6 Domovní zásobník – CNG',
        label: '6 Domovní zásobník – CNG',
    },
    {
        value: '7 Domovní zásobník – LNG',
        label: '7 Domovní zásobník – LNG',
    },
    {
        value: '8 Domovní zásobník – bioplyn',
        label: '8 Domovní zásobník – bioplyn',
    },
    {
        value: '9 Domovní zásobník – degazační',
        label: '9 Domovní zásobník – degazační',
    },
    {
        value: '10 Domovní zásobník – jiné',
        label: '10 Domovní zásobník – jiné',
    },
    {
        value: '11 Kombinované',
        label: '11 Kombinované',
    },
];
exports.ACCOMPANYING_REPORT_A3_ELEVATOR_OPTIONS = [
    {
        value: '1 Nezjištěno',
        label: '1 Nezjištěno',
    },
    {
        value: '2 S výtahem',
        label: '2 S výtahem',
    },
    {
        value: '3 S výtahem bezbariérovým',
        label: '3 S výtahem bezbariérovým',
    },
    {
        value: '4 Bez výtahu',
        label: '4 Bez výtahu',
    },
];
